document.addEventListener("DOMContentLoaded", function () {
    const categoriesWrapper = document.getElementById("categoriesWrapper");
    const scrollLeftBtn = document.getElementById("scrollLeft");
    const scrollRightBtn = document.getElementById("scrollRight");

    // Scroll amount (adjust as needed)
    const scrollAmount = 200;

    scrollLeftBtn.addEventListener("click", function () {
        categoriesWrapper.scrollBy({
            top: 0,
            left: scrollAmount,
            behavior: "smooth",
        });
    });

    scrollRightBtn.addEventListener("click", function () {
        categoriesWrapper.scrollBy({
            top: 0,
            left: -scrollAmount,
            behavior: "smooth",
        });
    });

    // Optional: Hide/show scroll buttons based on scroll position
    function updateScrollButtons() {
        const scrollLeft = categoriesWrapper.scrollLeft;
        const maxScrollLeft =
            categoriesWrapper.scrollWidth - categoriesWrapper.clientWidth;

        // Check if scrolling is possible
        const isScrollable =
            categoriesWrapper.scrollWidth > categoriesWrapper.clientWidth;

        // Show/hide buttons based on scrollability
        scrollLeftBtn.style.display = isScrollable ? "flex" : "none";
        scrollRightBtn.style.display = isScrollable ? "flex" : "none";

        if (isScrollable) {
            // Adjust button opacity based on scroll position
            scrollLeftBtn.style.opacity = Math.abs(scrollLeft) > 5 ? "1" : "0";
            scrollRightBtn.style.opacity =
                Math.abs(maxScrollLeft - Math.abs(scrollLeft)) > 5 ? "1" : "0";
        }
    }

    // Initial button state
    updateScrollButtons();

    // Update button visibility on scroll
    categoriesWrapper.addEventListener("scroll", updateScrollButtons);
    window.addEventListener("resize", updateScrollButtons);
});
